import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { MotionEventState } from "Interfaces";

const initialState: MotionEventState = {
	email: false,
	alarmOut: false,
	audioAlarm: false,
	interval: 0,
	recording: false,
	redBlueLight: false,
	snapshot: false,
	whiteLight: false,
	ftp: false
};

const setMotionEventReducer = (state: MotionEventState, action: PayloadAction<MotionEventState>) => {
	return action.payload;
};

const getMotionEvent = (state: MotionEventState) => {
	return state;
};

const motionEventSlice = createAppSlice({
	initialState,
	name: "motionEvent",
	reducers: {
		setMotionEventAction: setMotionEventReducer
	},
	selectors: {
		selectMotionEvent: getMotionEvent
	}
});

export default motionEventSlice;

export const { setMotionEventAction } = motionEventSlice.actions;
export const { selectMotionEvent } = motionEventSlice.selectors;
